import { useRouter } from 'next/router'

export const usePathname = () => {
  return useRouter().asPath
}

export const useSearchParams = <T extends Record<string, string | string[]>>(): Partial<T> => {
  return useRouter().query
}
